import { styled as r, Box as s, useMediaQuery as M } from "@mui/material";
import w from "../../adeptus-lib/components/AdeptusBelieverButton.js";
import D from "./PlayerIcon.js";
import { padNumber as y } from "../../common-lib/utils/string.js";
import g from "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import { SkeletonTypography as b } from "../../temp-lib/components/share/generic/Skeleton.js";
import { EmptyPublicAccount as j } from "../../temp-lib/constants/account.js";
import { useAccountContext as A } from "../../temp-lib/contexts/account/AccountContext.js";
import O from "../../temp-lib/hooks/graphql/useGetPublicAccountDetail.js";
import R from "../../temp-lib/styles/theme.js";
import h from "../../ui-lib/components/CopyButton.js";
import W from "../../wallet-lib/components/TokenSectionDesktop.js";
import q from "../../wallet-lib/components/TokenSectionMobile.js";
import { useRouter as k } from "next/router";
import * as l from "ramda";
import { useState as F } from "react";
import G from "use-async-effect";
import { jsx as t, Fragment as f, jsxs as n } from "react/jsx-runtime";
const P = r(s)`
  background-color: #4a4d5e;
  box-shadow: 0px 3px 10px #74e4f111;
  column-gap: 30px;
  display: flex;
  position: relative;
  width: 100%;

  ${(e) => e.theme.breakpoints.up("res1280")} {
    padding: 16px 90px;
  }
  ${(e) => e.theme.breakpoints.down("res1280")} {
    row-gap: 20px;
    flex-direction: column;
    align-items: center;
    padding: 16px 5%;
  }
`, C = r(s)`
  align-items: center;
  display: flex;
  justify-content: center;

  ${(e) => e.theme.breakpoints.up("res1280")} {
    gap: 10px;
  }
  ${(e) => e.theme.breakpoints.down("res1280")} {
    flex-direction: column;
  }
`, v = r(D)`
  width: 160px;
`, $ = r(s)`
  align-items: center;
  display: flex;
  gap: 14px;
`, N = r(s)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
  ${(e) => e.theme.breakpoints.up("res1280")} {
    max-width: 200px;
  }
  ${(e) => e.theme.breakpoints.down("res1280")} {
    max-width: 160px;
  }
`, S = r(s)`
  align-items: center;
  display: flex;
  gap: 5px;
  width: 100%;
`, T = r(b)`
  font-size: 18px;
  font-weight: 400;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.Custom-Typography-Skeleton {
    ${(e) => e.theme.breakpoints.up("res480")} {
      min-width: 150px;
    }
    ${(e) => e.theme.breakpoints.down("res480")} {
      min-width: 70px;
    }
  }
`, E = r(b)`
  color: #b9bbbe;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
  &.Custom-Typography-Skeleton {
    min-width: 50px;
  }
`, I = r(s)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`, H = r(g)`
  color: #b1b3b3;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
  width: 100%;
`, x = r(s)`
  align-items: center;
  display: flex;
  overflow: hidden;
  width: 100%;
`, u = r(g)`
  color: #b1b3b3;
  overflow: hidden;
  width: 100%;
  ${(e) => e.theme.breakpoints.up("res1280")} {
    font-size: 14px;
    line-height: 14px;
  }
  ${(e) => e.theme.breakpoints.down("res1280")} {
    font-size: 12px;
    line-height: 12px;
  }
  &.Custom-Typography-Skeleton {
    min-width: 180px;
  }
`, L = (e) => {
  const {
    className: a
  } = e, d = M(R.breakpoints.down("res768")), {
    account: o,
    isLoggedIn: p
  } = A(), i = l.isEmpty(o.name);
  return p ? /* @__PURE__ */ n(P, {
    className: a,
    children: [/* @__PURE__ */ t(C, {
      children: /* @__PURE__ */ n($, {
        children: [/* @__PURE__ */ t(v, {}), /* @__PURE__ */ n(N, {
          children: [/* @__PURE__ */ n(S, {
            children: [/* @__PURE__ */ t(T, {
              loading: i,
              children: o.name
            }), /* @__PURE__ */ n(E, {
              loading: i,
              children: ["# ", y(o.tag, 4)]
            })]
          }), /* @__PURE__ */ t(I, {
            children: o.email ? /* @__PURE__ */ n(f, {
              children: [/* @__PURE__ */ t(H, {
                children: o.email
              }), /* @__PURE__ */ n(x, {
                children: [/* @__PURE__ */ t(u, {
                  loading: i,
                  children: o.walletAddress
                }), /* @__PURE__ */ t(h, {
                  value: o.walletAddress
                })]
              }), /* @__PURE__ */ t(w, {
                account: o,
                loading: i
              })]
            }) : /* @__PURE__ */ n(x, {
              children: [/* @__PURE__ */ t(u, {
                loading: i,
                children: o.walletAddress
              }), /* @__PURE__ */ t(h, {
                value: o.walletAddress
              })]
            })
          })]
        })]
      })
    }), d ? /* @__PURE__ */ t(q, {}) : /* @__PURE__ */ t(W, {})]
  }) : /* @__PURE__ */ t(f, {});
}, Q = (e) => {
  const {
    className: a
  } = e, {
    query: d
  } = k(), o = l.propOr("", "ownerWalletAddresses", d), {
    fetch: p
  } = O(), [i, z] = F(null);
  G(async (B) => {
    if (!l.isEmpty(o)) {
      let m = await p({
        walletAddress: o
      });
      if (!B())
        return;
      l.isNil(m) && (m = {
        ...j,
        walletAddress: o
      }), z(m);
    }
  }, [o]);
  const c = l.isNil(i);
  return /* @__PURE__ */ t(P, {
    className: a,
    children: /* @__PURE__ */ t(C, {
      children: /* @__PURE__ */ n($, {
        children: [/* @__PURE__ */ t(v, {}), /* @__PURE__ */ n(N, {
          children: [/* @__PURE__ */ n(S, {
            children: [/* @__PURE__ */ t(T, {
              loading: c,
              children: i == null ? void 0 : i.name
            }), /* @__PURE__ */ n(E, {
              loading: c,
              children: ["# ", y((i == null ? void 0 : i.tag) || 0, 4)]
            })]
          }), /* @__PURE__ */ n(I, {
            children: [/* @__PURE__ */ n(x, {
              children: [/* @__PURE__ */ t(u, {
                loading: c,
                children: i == null ? void 0 : i.walletAddress
              }), /* @__PURE__ */ t(h, {
                value: (i == null ? void 0 : i.walletAddress) || ""
              })]
            }), /* @__PURE__ */ t(w, {
              account: i,
              loading: c
            })]
          })]
        })]
      })
    })
  });
}, de = (e) => {
  const {
    query: a,
    isReady: d
  } = k(), {
    ownerWalletAddresses: o
  } = a, {
    account: p
  } = A(), i = !l.isNil(o) && p.walletAddress !== o;
  return d ? i ? /* @__PURE__ */ t(Q, {
    ...e
  }) : /* @__PURE__ */ t(L, {
    ...e
  }) : /* @__PURE__ */ t(f, {});
};
export {
  de as default
};
//# sourceMappingURL=AccountHeader.js.map
